module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro1-old.e5eb9bdb.mp3";